/**
 * 导出通用配置
 */
module.exports = {
  // 标题，此项修改后需要重启项目
  title: '工具岛',
  // 网站标题
  siteTitle: 'AI工具岛 - 探索AI之境，从此岛开始。',
  // 网站加载时显示的内容
  siteLoading: '正在为您加载系统资源，请耐心等待',
  // 网站描述
  siteDescription:
    'AI工具岛致力于打造最直观的AI工具库。我们坚信，工具的价值在于被高效地使用。因此，我们不仅聚合，更精心评测、清晰分类与实时更新，让每一位探索者都能在这里：快速发现所需、轻松比较优劣、即刻启程应用。从这里出发，让AI真正为你所用，高效查找各类网站就选AI工具岛！',
  // 网站关键字
  siteKeywords:
    'AI工具岛, 导航, AI导航, AI工具导航, 智能导航, 人工智能工具, 实用AI工具, 最新AI工具, 免费AI工具, AI工具大全, AI工具集合, AI工具推荐, AI工具评测, 效率工具, 创意工具, 写作AI, 绘画AI, 编程AI, 设计工具, 办公自动化, 个性化导航, 自定义导航, 好用的导航网站, 网站大全',
  // 白名单配置，不用令牌就能访问
  whileList: ['/', '/login', '/about'],
  // 超级管理员
  superAdmin: 'superAdmin',
  // 所有权限
  allPermission: '*:*:*',
  // 备案号
  recordTitle: ''
}
